import Marquee from "@/components/ui/marquee";
import { ProgressIcon } from "@/components/home/ProgressIcon/ProgressIcon";
import { motion } from "framer-motion";
import { goals } from "@/components/home/ProgressGoals/ProgressGoals.data";
import { useTranslation } from "@/hooks/useTranslation";

export function ProgressGoals() {
  const { t } = useTranslation();

  return (
    <motion.section
      data-testid="goals-marquee"
      id="goals-marquee"
      initial={{ opacity: 0 }}
      whileInView={{ opacity: 1 }}
      viewport={{ once: true }}
      transition={{ duration: 0.5, ease: "easeOut" }}
      className="col-span-12 relative overflow-hidden w-[100vw] left-[50%] right-[50%] -ml-[50vw] -mr-[50vw]"
    >
      <Marquee className="h-[200px] flex items-center">
        {goals.map((goal) => (
          <div key={goal.id}>
            <ProgressIcon
              type="goal"
              text={t(goal.textKey)}
              icon={goal.icon}
              color={goal.color}
              className="mx-6"
              usePortal={false}
            />
          </div>
        ))}
      </Marquee>
    </motion.section>
  );
}
